// src/services/adoptionAPI.js
import api from './api';

export const adoptionAPI = {
  // Create an adoption post
  createAdoptionPost: (data) => {
    const formData = new FormData();

    // Handle pet IDs (single or multiple)
    if (Array.isArray(data.pet_ids)) {
      data.pet_ids.forEach((id, index) => {
        formData.append(`pet_ids[${index}]`, id);
      });
    } else {
      formData.append('pet_ids[]', data.pet_ids);
    }

    formData.append('about_pet', data.about_pet || '');
    formData.append('looking_for', data.looking_for || '');

    // Vaccinated flag (optional boolean)
    // Many backends expect booleans as 1/0 in multipart form-data
    if (typeof data.vaccinated === 'boolean') {
      formData.append('vaccinated', data.vaccinated ? '1' : '0');
    }

    // Handle additional images
    if (data.additional_images && Array.isArray(data.additional_images)) {
      data.additional_images.forEach((file, index) => {
        if (file instanceof File) {
          formData.append(`additional_images[${index}]`, file);
        }
      });
    }

    return api.post(`${import.meta.env.VITE_API_URL}/api/v1/adoption/posts`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Get all adoption posts
  getAdoptionPosts: (params = {}) => {
    return api.get(`${import.meta.env.VITE_API_URL}/api/v1/adoption/posts`, { params });
  },

  // Send an adoption request
  sendAdoptionRequest: (postId, data = {}) => {
    return api.post(`${import.meta.env.VITE_API_URL}/api/v1/adoption/posts/${postId}/requests`, data);
  },

  // Get adoption requests for current user's posts
  getAdoptionRequests: (params = {}) => {
    return api.get(`${import.meta.env.VITE_API_URL}/api/v1/adoption/requests`, { params });
  },

  // Accept an adoption request
  acceptAdoptionRequest: (requestId) => {
    return api.post(`${import.meta.env.VITE_API_URL}/api/v1/adoption/requests/${requestId}/accept`);
  },

  // Reject an adoption request
  rejectAdoptionRequest: (requestId) => {
    return api.post(`${import.meta.env.VITE_API_URL}/api/v1/adoption/requests/${requestId}/reject`);
  },

  // Cancel an adoption request (by the requester)
  cancelAdoptionRequest: (requestId) => {
    return api.delete(`${import.meta.env.VITE_API_URL}/api/v1/adoption/requests/${requestId}`);
  },

  // Clear adoption requests history (delete non-pending)
  clearAdoptionRequestsHistory: () => {
    return api.delete(`${import.meta.env.VITE_API_URL}/api/v1/adoption/requests/clear-history`);
  },

  // Delete an adoption post
  deleteAdoptionPost: (postId) => {
    return api.delete(`${import.meta.env.VITE_API_URL}/api/v1/adoption/posts/${postId}`);
  },

  // Update an adoption post
  updateAdoptionPost: (postId, data) => {
    const formData = new FormData();

    // Handle pet IDs (single or multiple)
    if (Array.isArray(data.pet_ids)) {
      data.pet_ids.forEach((id, index) => {
        formData.append(`pet_ids[${index}]`, id);
      });
    } else {
      formData.append('pet_ids[]', data.pet_ids);
    }

    formData.append('about_pet', data.about_pet || '');
    formData.append('looking_for', data.looking_for || '');

    // Vaccinated flag (optional boolean)
    if (typeof data.vaccinated === 'boolean') {
      formData.append('vaccinated', data.vaccinated ? '1' : '0');
    }

    // Handle additional images
    if (data.additional_images && Array.isArray(data.additional_images)) {
      data.additional_images.forEach((file, index) => {
        if (file instanceof File) {
          formData.append(`additional_images[${index}]`, file);
        }
      });
    }

    // Handle removed images if any
    if (data.removed_image_ids && Array.isArray(data.removed_image_ids)) {
      data.removed_image_ids.forEach((id, index) => {
        formData.append(`removed_image_ids[${index}]`, id);
      });
    }

    return api.post(`${import.meta.env.VITE_API_URL}/api/v1/adoption/posts/${postId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        _method: 'PUT'
      }
    });
  },

  // Share an adoption post to social feed
  shareAdoptionPost: (adoptionPostId, content = '') => {
    return api.post(`${import.meta.env.VITE_API_URL}/api/v1/adoption/posts/${adoptionPostId}/share`, {
      content: content,
    });
  },

  // Check if user has already shared an adoption post
  getAdoptionPostShareStatus: (adoptionPostId) => {
    return api.get(`${import.meta.env.VITE_API_URL}/api/v1/adoption/posts/${adoptionPostId}/share-status`);
  },
};

